import { Text } from '@cabonline/ui-web';
import { FC } from 'react';

import { StyledNavLink, StyledRotatedRouteIconWrapper } from './styles';
import { MenuLinkProps } from './types';

export const MenuLink: FC<MenuLinkProps> = ({
  to,
  label,
  icon,
  rotateIcon = false,
  onClick,
}) => (
  <StyledNavLink to={to} onClick={onClick}>
    {icon &&
      (rotateIcon ? (
        <StyledRotatedRouteIconWrapper>{icon}</StyledRotatedRouteIconWrapper>
      ) : (
        icon
      ))}
    <Text weight="extraBold" size="m">
      {label}
    </Text>
  </StyledNavLink>
);
